import { baseApi, PaginatedResponse } from 'sama-shared';
import type { AdminPartner } from '../types/admin';
import type { GetPartnersParams } from '../types/api';
import type { CreatePartnerDto } from '../types/dto';

export const partnersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPartners: builder.query<PaginatedResponse<AdminPartner>, GetPartnersParams>({
      query: (params) => ({
        url: '/admin/partner',
        method: 'GET',
        params,
      }),
      providesTags: (result) =>
        result && result.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Partner' as const, id })),
              { type: 'Partner', id: 'LIST' },
            ]
          : [{ type: 'Partner', id: 'LIST' }],
    }),
    getPartnerById: builder.query<AdminPartner, string>({
      query: (id) => ({
        url: `/admin/partner/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Partner', id }],
    }),
    createPartner: builder.mutation<AdminPartner, CreatePartnerDto>({
      query: (body) => ({
        url: '/admin/partner',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Partner', id: 'LIST' }],
    }),
    updatePartner: builder.mutation<AdminPartner, any & { id: string }>({
      query: ({ id, ...body }) => ({
        url: `/admin/partner/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'Partner', id }],
    }),
    deletePartner: builder.mutation<void, string>({
      query: (id) => ({
        url: `/admin/partner/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Partner', id: 'LIST' }],
    }),
    downloadBulkTemplate: builder.query<Blob, string>({
      query: (partnerId) => ({
        url: `/product/admin/${partnerId}/bulk-upload/template`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
  overrideExisting: false,
});

// Exportas solo los hooks de este dominio
export const {
  useGetPartnersQuery,
  useGetPartnerByIdQuery,
  useLazyGetPartnerByIdQuery,
  useCreatePartnerMutation,
  useUpdatePartnerMutation,
  useDeletePartnerMutation,
  useLazyDownloadBulkTemplateQuery,
} = partnersApi;
